module.exports = __webpack_public_path__ + "static/media/blueQuestionMark.c32f7aca.svg";